var dayjs_min = {exports: {}};

export { dayjs_min as __module };
//# sourceMappingURL=dayjs.min2.js.map
